import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import Folder from 'src/app/Models/Base/folder';
import { ConstService } from '../Const/const.service';
import { AccessService } from '../Access/access.service';
import { NavigationExtras, Router } from '@angular/router';
import { AccountService } from '../Account/account.service';
import { LoginAccountResult } from 'src/app/Models/Account/login-account-result';
import { CompaniesByUserResult } from 'src/app/Models/Empresa/empresaModel';
import { ProductByCompaniesResult } from 'src/app/Models/Product/product_model';
import { LastAccessResult } from 'src/app/Models/Access/last-access-result';
import { CompanyService } from '../Company/company.service';
import Base from 'src/app/Models/Base/base';
import { ListTwoFactorTypesResult } from 'src/app/Models/TwoFactor/two-factor-result';
import { SetTwoFactorResult } from 'src/app/Models/TwoFactor/set-twoFactor-result';
import { GetCommunityAccessResult } from 'src/app/Models/Account/getComunityAccess';
import { ListTwoFactorByUserResult } from 'src/app/Models/TwoFactor/list-twoFactorByUser-result';
import { ProductByCategoriesResult } from 'src/app/Models/Product/productsCategories_model';
import { GetUsersResult } from 'src/app/Models/Account/user-data';
import { getPermissionsByCU } from 'src/app/Models/Account/getPermissionsByCU-Result';
import {
  GetUserInfoResult,
} from 'src/app/Models/Account/getUserInfo-result';
import { GetErpUsersResult } from 'src/app/Models/Account/getErpUser-result';
import Rutas from 'src/app/Models/Base/rutas';
import { catchError, map } from 'rxjs/operators';
import { BehaviorSubject, forkJoin, Observable, of } from 'rxjs';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Platform } from '@angular/cdk/platform';
import { setLocalStorage, getLocalStorage, getToken, deleteAllCookies } from 'npx-arc-ui/utils';
import { TwoFactorService } from '../TwoFactor/two-factor.service';
import { ProductService } from '../Product/product.service';
import { UserService } from '../User/user.service';
import { DOCUMENT } from '@angular/common';
import { ListUsersComponent } from 'src/app/Components/list-users/list-users.component';
import Storage from 'src/app/Models/Base/storage';
import { productAccessControlListResult } from 'src/app/Models/Product/access_product';
import { ModalConfirmationComponent, TYPE_MODAL } from 'src/app/Components/modal-confirmation/confirmation.component';
import { MatPaginator } from '@angular/material/paginator';
import { MatDialog } from '@angular/material/dialog';
import { IntercomHelperService } from '../Utils/intercom.service';
import { ServicioSnackbar } from 'npx-arc-ui/snackbar';
import { take } from 'rxjs/operators';
import { GetUserCompanyInfo } from 'src/app/Models/Company/get-user-company-info-result';

@Injectable({
  providedIn: 'root',
})
export class AppStateService {
  public folder: Folder = new Folder();
  public loading: boolean = false;
  public loadingProd: boolean = false;
  public Access_Token: string = '';
  public Access_Code: string = '';
  public GetListcompany!: CompaniesByUserResult;  
  public ListPaginator!: MatPaginator;
  public UserCompanyInfo = new BehaviorSubject<GetUserCompanyInfo>({
    showAdminBanner: false, 
    expirationDate: null, 
    hasSubscription: false, 
    isAdmin: false,
    subscriptionType: null, 
    pais: null, 
    name: null, 
    email: null,
    annualAmount: null,
    blocked: false,
    onboardingStatus: 0
  });
  public ExpirationBanner: string | null = null;
  public estadoOnboarding: number = 0;
  public usuarioBloqueado: boolean = false;
  public LastAccessString!: LastAccessResult;
  public SearchProductByCompanie!: ProductByCompaniesResult;
  public LoginResult!: LoginAccountResult;
  public urlIframe: string = '';
  public ListTwoFactorTypesResult!: ListTwoFactorTypesResult;
  public GetCommunityAccessResult!: GetCommunityAccessResult;
  public SetTwoFactorResult!: SetTwoFactorResult;
  public productName: string = '';
  public ListTwoFactorByUserResult!: ListTwoFactorByUserResult;
  public ProductByCategoriesRes!: ProductByCategoriesResult;
  public returnProduct: string = '';
  public ListTwoFactorForgotResult!: ListTwoFactorByUserResult;
  public GetUsersResultVar!: GetUsersResult;
  public getPermissionsByCU!: getPermissionsByCU;
  public GetUserInfoResult!: GetUserInfoResult;
  public GetUserErpResult!: GetErpUsersResult;
  public loginValues!: { email: string; password: string; id_prod: string };
  public loginValuesSupport!: { clientid: string; password: string, userid:string };
  public ListproductAccess!: productAccessControlListResult;
  public SecretLogin: boolean = false;
  public IsSupport : boolean = false;
  public OneCompany: boolean = false;


  
  //Servicios
  AccessServices: AccessService;
  CompanyServices: CompanyService;
  AccountService: AccountService;
  TwoFactorService: TwoFactorService;
  ProductService: ProductService;
  UserService: UserService;
  constructor(
    public http: HttpClient,
    public dialog: MatDialog,
    public router: Router,
    public breakpointObserver: BreakpointObserver,
    public platform: Platform,
    @Inject(DOCUMENT) public document: Document,
    public intercom: IntercomHelperService,
    private alerta: ServicioSnackbar
  ) {
    this.AccessServices = new AccessService(this);
    this.AccountService = new AccountService(this);
    this.CompanyServices = new CompanyService(this);
    this.TwoFactorService = new TwoFactorService(this);
    this.ProductService = new ProductService(this);
    this.UserService = new UserService(this);
  }

  /**
   * @description Permite identificar en que dispositivo se esta visualizando el portal
   */
  public get isMobile(): boolean {
    return this.breakpointObserver.isMatched([Breakpoints.XSmall]) || this.platform.ANDROID || this.platform.IOS || this.platform.SAFARI;
  }

  /**
   * @description Sistema de alertas by Defontana
   * @param type Es el tipo de alerta que se desea mostrar: **error** | **success** | **warning**
   * @param message Es el mensaje que se desea mostrar en el modal
   */
  public showMiniMessage(message: string, type: 'error' | 'success' | 'warning') {
    switch (type) {
      case 'error':
        this.alerta.muestraMensajeError(message)
        break;

      case 'warning':
        this.alerta.muestraMensajeWarning(message)
        break;
    
      default:
        this.alerta.muestraMensajeExito(message)
        break;
    }
  }

  /**
   * @description Limpia el objeto global del paginado
   */
  public cleanPaginator(): void {
    this.folder = new Folder();
  }

  get Email() {
    return getLocalStorage<string>(Storage.EMAIL)?.data || ''
  }

  get CompanyName() {
    return getLocalStorage<string>(Storage.COMPANY_NAME)?.data || ''
  }

  get LastAccess() {
    return getLocalStorage(Storage.LAST_ACCESS)?.data || ''
  }

  /**
   * @description Ya validado el login con metodo de una API pasa la informacion del login a
   * ser registrado en una cookie con un limite de tiempo de 1 dia, para que el **GUARD** lo busque
   * y permita al usuario ingresar a las demas pantallas.
   */

  onPostLogin(id_prod: string = '') {
    //Multiples consultas anidadas
    forkJoin({
      list: this.CompanyServices.GetList().pipe(catchError(c => of<Base>({ success: false, message: c || 'Error en listado' })))
      , lastAccess: this.UserService.GetLastAccess().pipe(catchError(c => of<Base>({ success: false, message: c || 'Error en ultimo acceso' })))
      , userCompany: this.CompanyServices.GetUserCompanyInfo().pipe(catchError(c => of<Base>({ success: false, message: c || 'Error en la información del usuario' })))
    })
    .subscribe(({
      list
      , lastAccess
      , userCompany
    }) =>{
      //Empresa seleccionada por defecto
      if(list.success && 'companyList' in list && !!list.companyList.length){
        setLocalStorage(Storage.COMPANY_NAME, list.companyList[0].companyName);
      }
      //Obtenemos informacion del usuario asociado a la empresa
      if(userCompany.success && 'expirationDate' in userCompany){
        const { success, message, exception, ...informacion } = userCompany;
        this.UserCompanyInfo.next({
          ...informacion
        })
      }

      this.loading = false
      //Iniciar Store global con toda esta información
      if(id_prod === ''){
        this.router.navigateByUrl(Rutas.DASHBOARD);
      }
      else{
        //se debe abrir la url del producto
        this.loadProductAndUserData(id_prod);
      }
    })    
  }

private loadProductAndUserData(_Idprod: string): void {
  this.loading = true;

  forkJoin({
    productResult: this.ProductService
      .GetProductsByCompanyAndUser()
      .pipe(
        take(1),
        map(r => r.productList.find(p => p.code === _Idprod))
      ),
    usersResult: this.AccountService
      .GetUsersFromAccount(this.folder.itemsPerPage, 0)
      .pipe(take(1))
  })
  .subscribe({
    next: ({ productResult, usersResult }) => {
      const product = productResult as any;
      const user = usersResult.users?.[0]?.user;

      if (!user || !product) return;

      this.folder.totalItems = usersResult.totalItems;
      this.ProductService.setErpLogin(
        _Idprod,
        product.isPublic,
        product.name,
        user,
        true
      );
    },
    complete: () => (this.loading = false)
  });
}
  /**
   * **IsAuthGuard**
   * @description verifica si el usuario esta autentificado con login o con token, ademas valida si el **access** ingresado en la cookie
   * este correcto.
   * @returns {boolean}
   */
  public IsAuthGuard(): boolean {
    const hasToken = getLocalStorage<string>(Storage.TOKEN)?.data;
    if(!!hasToken){
      try {
        const account = getToken(hasToken);
        return !!account;
      } catch (error) {
        throw new Error('Error en autentificación de usuario');
      }
    }
    else
      return false;
  }

  onLogin(payload: { email: string, password: string, id_prod: string}, rethrowError = false ) {
    this.loading = true;
    this.loginValues = payload;
    return this.AccountService.AccountLoginEmail(payload)
        .toPromise()
          .then((res) => {
            const {
              expiredPassword,
              haveCompanies,
              twoFactorEnabled,
              lockedAccount,
              token
            } = res;
            !!token.length && setLocalStorage(Storage.EMAIL, payload.email);
            const navigationExtras: NavigationExtras = { state: { token } };
            this.LoginResult = res;
            //Bloqueo
            if (lockedAccount) {
              this.loading = false;
              const navigationExtras: NavigationExtras = { state: { token: '-' } };
              this.router.navigateByUrl(Rutas.BLOCKED, { state: navigationExtras });
            }
            //Expiracion
            else if (expiredPassword) {
              this.loading = false;
              this.router.navigate([Rutas.EXPIRATION], { state: navigationExtras });
            }
            //hasCompanies
            else if (haveCompanies != null && !haveCompanies) {
              this.loading = false;
              this.router.navigate([Rutas.ASSOCIATION], { state: navigationExtras });
            }
            //doble auth
            else if (twoFactorEnabled) {
              this.loading = false;
              this.router.navigate([Rutas.DOUBLE_FACTOR], { state: navigationExtras });
            } else {
              if (!res.success) {
                this.loading = false;
                this.showMiniMessage(res?.message || 'Error de autenticación','error');
                if (rethrowError) {
                  throw new Error(res?.message || 'Error de autenticación');
                }
              } else {
                setLocalStorage(Storage.SUPPORT_LOGIN, '0')
                //Si el token viene se almacena en el storage
                !!token && setLocalStorage(Storage.TOKEN, token);
                this.onPostLogin(payload.id_prod);
              }
            }
          })
          .catch((err) => {
            this.loading = false;
            if (rethrowError) {
              throw err;
            }
            this.router.navigateByUrl(Rutas.LOGIN);
          });
  }

  public GetPermissionsByCompanyAndUser() {
    let url = `${ConstService.URLApi}/Permissions/GetPermissionsByCompanyAndUser`;
    this.http.get<getPermissionsByCU>(url).subscribe(
      (res) => {
        if (res.success) {
          this.getPermissionsByCU = res;
        } else {
          this.loading = false;
          this.showMiniMessage(res.message, 'error');
        }
      },
      (err) => {
        this.showMiniMessage(
          'Error interno, por favor intentar más tarde.',
          'error'
        );
      }
    );
  }

  public openConfirming({
    type,
    title,
    subtitle
  }: {
    type: TYPE_MODAL;
    title: string;
    subtitle?: string
  }): Observable<{ confirm: boolean } | null> {
    const dialogRef = this.dialog.open(ModalConfirmationComponent, {
      width: '480px',
      maxWidth: '95%',
      maxHeight: '95%',
      data: { type, title, subtitle },
    });

    return dialogRef.afterClosed().pipe(
      map((r) => {
        return { ...r };
      })
    );
  }

  onSelectProduct(code: string, isPublic: boolean, name: string){
    deleteAllCookies();
    this.loading = true;
    this.AccountService
    .GetUsersFromAccount()
    .subscribe(({success, oneUser, users, totalItems}) =>{
      this.loading = !true;
      if(success && oneUser){
        this.ProductService.setErpLogin(code, isPublic, name,users[0].user)
      }
      else{
        const dialogRef = this.dialog.open(ListUsersComponent, {
          maxWidth: '95%',
          maxHeight: '85%',
          width: '570px',
          data: {
            paginator: { data: users, totalItems }
          }
        });

        dialogRef
        .beforeClosed()
        .subscribe(({userId}) =>{
          if(userId){
            this.ProductService.setErpLogin(code, isPublic, name, userId);
          }
        })
      }
    },
    err =>{
      this.loading = false;
    })
  }

  public SetPermissionsByAdmin(
    accountID: string,
    setAdmin?: boolean,
    setCompanyAccess?: boolean
  ): void {
    this.loading = true;
    var url: string = `${ConstService.URLApi}/Permissions/SetPermissionsByAdmin`;
    var body: any = new Object();
    body = {
      accountID: accountID,
      setAdmin: setAdmin,
      setCompanyAccess: setCompanyAccess,
    };
    this.http.post<Base>(url, body).subscribe((res: any) => {
      if (res.success) {
        window.location.reload();
        this.showMiniMessage('Proceso éxitoso', 'success');
      } else {
        this.loading = false;
        this.showMiniMessage(res.message, 'error');
      }
    });
  }

  public SetAllCompanyAccessAsync(accountID: string): void {
    this.loading = true;
    var url: string = `${ConstService.URLApi}/Permissions/SetAllCompanyAccessAsync`;
    var body: any = new Object();
    body = {
      accountID: accountID,
    };
    this.http.post<Base>(url, body).subscribe((res: any) => {
      if (res.success) {
        this.loading = false;
        this.showMiniMessage('Proceso éxitoso', 'success');
      } else {
        this.loading = false;
        this.showMiniMessage(res.message, 'error');
      }
    });
  }

  public onLogOut() {
    localStorage.clear();
    deleteAllCookies();
    this.router.navigateByUrl(Rutas.LOGIN);
  }

  onLoginSupport(payload: { clientid: string, password: string,userid :string }) {
    this.loading = true;
    this.loginValuesSupport = payload;
    this.AccountService.AccountLoginSupport(payload)
        .toPromise()
          .then((res) => {
            
            const {
              expiredPassword,
              haveCompanies,
              twoFactorEnabled,
              lockedAccount,
              token
            } = res;
            
            !!token.length && setLocalStorage(Storage.EMAIL, res.email);
            const navigationExtras: NavigationExtras = { state: { token } };
            this.LoginResult = res;
            //Bloqueo
            
            if (lockedAccount) {
              this.loading = false;
              const navigationExtras: NavigationExtras = { state: { token: '-' } };
              this.router.navigateByUrl(Rutas.BLOCKED, { state: navigationExtras });
            }
            //Expiracion
            else if (expiredPassword) {
              this.loading = false;
              this.router.navigate([Rutas.EXPIRATION], { state: navigationExtras });
            }
            //hasCompanies
            else if (haveCompanies != null && !haveCompanies) {
              this.loading = false;
              this.router.navigate([Rutas.ASSOCIATION], { state: navigationExtras });
            }
            //doble auth
            else if (twoFactorEnabled) {
              this.loading = false;
              this.router.navigate([Rutas.DOUBLE_FACTOR], { state: navigationExtras });
            } else {
              
              if (!res.success) {
                this.loading = false;
                this.showMiniMessage(res?.message || 'Error de autenticación','error');
              } else {
                //Si el token viene se almacena en el storage
                setLocalStorage(Storage.SUPPORT_LOGIN, '1')
                !!token && setLocalStorage(Storage.TOKEN, token);
                this.onPostLogin('');
              }
            }
          })
          .catch((err) => {
            this.showMiniMessage('Error de autenticación','error');
            this.loading = false;
            this.router.navigateByUrl(Rutas.LOGIN);
          });
  }

}
